import { Link, useLocation } from "react-router-dom";
import { MapPin, Home, Compass, Map, ShoppingBag, Gamepad2 } from "lucide-react";
import { useLang } from "@/lib/lang";

export default function NavBar({ variant = "light" }) {
  const { lang, setLang } = useLang();
  const loc = useLocation();
  const items = [
    { to: "/", icon: Home, fr: "Accueil", en: "Home", testId: "nav-home" },
    { to: "/explorer", icon: Compass, fr: "Explorer", en: "Explore", testId: "nav-explorer" },
    { to: "/map", icon: Map, fr: "Carte", en: "Map", testId: "nav-map" },
    { to: "/games", icon: Gamepad2, fr: "Jeux", en: "Games", testId: "nav-games" },
    { to: "/store", icon: ShoppingBag, fr: "Store", en: "Store", testId: "nav-store" },
  ];

  const active = (to) => loc.pathname === to || (to !== "/" && loc.pathname.startsWith(to));

  return (
    <header className={`sticky top-0 z-30 border-b backdrop-blur ${variant === "dark" ? "bg-black/70 border-white/10 text-white" : "bg-white/95 border-zinc-200 text-zinc-900"}`}
      data-testid="main-navbar">
      <div className="max-w-6xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 text-[#8b6f3d] shrink-0" data-testid="nav-logo">
          <MapPin size={18} strokeWidth={1.5} />
          <span className="font-mono-data text-xs tracking-widest uppercase hidden sm:inline">Atlas · 0.4</span>
        </Link>

        <nav className="flex items-center gap-1 flex-1 justify-center">
          {items.map(({ to, icon: Icon, fr, en, testId }) => {
            const isActive = active(to);
            return (
              <Link
                key={to}
                to={to}
                data-testid={testId}
                className={`flex items-center gap-1.5 px-3 md:px-4 h-10 rounded-full text-sm font-medium transition-colors
                  ${isActive
                    ? "bg-[#8b6f3d] text-white"
                    : variant === "dark"
                      ? "text-white/80 hover:bg-white/10 hover:text-white"
                      : "text-zinc-700 hover:bg-zinc-100"
                  }`}
              >
                <Icon size={15} />
                <span className="hidden sm:inline">{lang === "fr" ? fr : en}</span>
              </Link>
            );
          })}
        </nav>

        <div className={`flex items-center gap-1 border rounded-full px-1 py-1 shrink-0 ${variant === "dark" ? "border-white/20" : "border-zinc-200"}`}>
          {["fr", "en"].map(code => (
            <button
              key={code}
              data-testid={`nav-lang-${code}`}
              onClick={() => setLang(code)}
              className={`px-2.5 py-1 rounded-full text-[11px] font-mono-data uppercase tracking-wider transition-colors
                ${lang === code
                  ? "bg-[#8b6f3d] text-white"
                  : variant === "dark" ? "text-white/60" : "text-zinc-500"
                }`}
            >
              {code}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
